import React, { useState, useEffect } from 'react'
import Classes from './Table.module.css'
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';
import useScreenWidth from '../../../../../../../Hooks/useScreenWidth';

export default function Table() {
    const initialOrders = [
        { id: 1, name: "DataVault360", risk: "High", Info: "Address", status: "Completed" },
        { id: 2, name: "ShopSmartly", risk: "High", Info: "Phone", status: "Completed" },
        { id: 3, name: "AutoQuotesAI", risk: "High", Info: "Email", status: "Completed" },
        { id: 4, name: "PrivacyGuard", risk: "High", Info: "Phone", status: "Completed" },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const currentItems = initialOrders.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <div className={Classes.table} >
            <div className={Classes.tableWrapper}>

                <div className={Classes.tableHeader}>
                    <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                        <h5>Broker Name</h5>
                    </div>
                    <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                        <h5>Risk Factor</h5>
                    </div>
                    <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                        <h5>Info Found</h5>
                    </div>
                    <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                        <h5>Deletion Status</h5>
                    </div>
                </div>

                {currentItems.map((cust, idx) => (
                    <TableRow
                        key={cust._id}
                        value={cust}
                        index={idx}
                    />
                ))}

            </div>
        </div>
    )
}
